// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HlLd","fullView":"styles_fullView__3d73G"};